function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import CartItem from '../CartItem';
import PropTypes from 'prop-types';
import _isNaN from 'lodash/isNaN';
import { translate, getCartLocalStorage, setCartLocalStorage } from '../../utils/helpers';
import SubmitPage from './SubmitPage';
import EmptyCartPage from './EmptyCartPage'; // import TotalCart from '../TotalCart'

var CartPage = /*#__PURE__*/function (_Component) {
  _inherits(CartPage, _Component);

  var _super = _createSuper(CartPage);

  function CartPage(props) {
    var _this;

    _classCallCheck(this, CartPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCommentsChange", function (event) {
      _this.setState({
        comments: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e, productId) {
      var otherProducts = _this.state.otherProducts.map(function (product) {
        if (product.id === productId) {
          var val = e.target.value;

          if (e.target.name === 'product_quantity') {
            val = _isNaN(parseInt(val, 10)) ? '' : parseInt(val, 10);
          }

          if (e.target.name === 'product_code' && val !== '') {
            product.product_quantity = 1;
          } else if (e.target.name === 'product_code' && val === '') {
            product.product_quantity = '';
          }

          return _objectSpread(_objectSpread({}, product), {}, _defineProperty({}, e.target.name, val));
        }

        return product;
      });

      _this.setState({
        otherProducts: otherProducts
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeItem", function (uniqId) {
      var cart = getCartLocalStorage().filter(function (item) {
        return item.uniqId !== uniqId;
      });

      _this.setState({
        cart: cart
      });

      setCartLocalStorage(cart);
    });

    _defineProperty(_assertThisInitialized(_this), "updateQuantity", function (uniqId, quantity) {
      var cart = getCartLocalStorage().map(function (item) {
        if (item.uniqId === uniqId) {
          return _objectSpread(_objectSpread({}, item), {}, {
            quantity: quantity
          });
        }

        return item;
      });

      _this.setState({
        cart: cart
      });

      setCartLocalStorage(cart);
    });

    _defineProperty(_assertThisInitialized(_this), "sendSubmission", function () {
      _this.setState({
        otherProducts: _this.state.otherProducts.filter(function (p) {
          return p.product_code !== '' && p.product_quantity;
        })
      });

      _this.setState({
        submitted: true
      });

      setTimeout(function () {
        return _this.setState({
          disabled: false
        });
      }, 2000);
    });

    _defineProperty(_assertThisInitialized(_this), "getCartIcon", function () {
      return document.querySelector('#shop-page').getAttribute('cart-icon');
    });

    _defineProperty(_assertThisInitialized(_this), "getCartRules", function () {
      return document.querySelector('#shop-page').getAttribute('cart-rules');
    });

    _defineProperty(_assertThisInitialized(_this), "getEmailBranch", function () {
      return document.querySelector('#shop-page').getAttribute('email-branch');
    });

    _defineProperty(_assertThisInitialized(_this), "getPhoneBranch", function () {
      return document.querySelector('#shop-page').getAttribute('phone-branch');
    });

    _this.state = {
      cart: [],
      products: [],
      disabled: false,
      submitted: false,
      comments: '',
      otherProducts: [{
        id: 0,
        product_code: '',
        product_desc: '',
        product_quantity: ''
      }, {
        id: 1,
        product_code: '',
        product_desc: '',
        product_quantity: ''
      }, {
        id: 2,
        product_code: '',
        product_desc: '',
        product_quantity: ''
      }, {
        id: 3,
        product_code: '',
        product_desc: '',
        product_quantity: ''
      }, {
        id: 4,
        product_code: '',
        product_desc: '',
        product_quantity: ''
      }]
    };
    return _this;
  }

  _createClass(CartPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        cart: getCartLocalStorage()
      }, function () {
        //self clean cart if the product doesn't have a variation
        var cart = _this2.state.cart.filter(function (item) {
          return item.uniqId !== undefined;
        });

        _this2.setState({
          cart: cart
        });

        setCartLocalStorage(cart);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          cart = _this$state.cart,
          disabled = _this$state.disabled,
          otherProducts = _this$state.otherProducts;
      return /*#__PURE__*/React.createElement("div", {
        className: "cart"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, this.state.cart <= 0 ? /*#__PURE__*/React.createElement(EmptyCartPage, {
        cartIcon: this.getCartIcon()
      }) : this.state.submitted === true ? /*#__PURE__*/React.createElement(SubmitPage, {
        disabled: disabled,
        cart: cart,
        otherProducts: otherProducts,
        comments: this.state.comments
      }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        className: "main-bg-after"
      }, ' ', translate('Your cart', 'Votre panier')), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 items-container"
      }, this.state.cart <= 0 ? null : /*#__PURE__*/React.createElement("div", {
        className: "cart-header d-none d-sm-none d-md-flex"
      }, /*#__PURE__*/React.createElement("span", null, translate('QUANTITY', 'QUANTITÉ'))), cart.map(function (item) {
        return item.uniqId && /*#__PURE__*/React.createElement(CartItem, {
          key: item.uniqId,
          item: item,
          removeItem: _this3.removeItem,
          updateInputValue: _this3.updateInputValue,
          updateQuantity: _this3.updateQuantity
        });
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 bottom-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-lg-7 col-md-12 rules-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "product-table"
      }, /*#__PURE__*/React.createElement("span", null, translate('OTHER PRODUCTS', 'AUTRES PRODUITS')), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
        className: "title main-bg"
      }, /*#__PURE__*/React.createElement("th", {
        style: {
          width: '30%'
        }
      }, translate('PRODUCT CODE', 'CODE PRODUIT')), /*#__PURE__*/React.createElement("th", {
        style: {
          width: '50%'
        }
      }, translate('DESCRIPTION', 'DESCRIPTION')), /*#__PURE__*/React.createElement("th", {
        style: {
          width: '20%'
        }
      }, translate('QUANTITY', 'QUANTITÉ'))), this.state.otherProducts.map(function (product) {
        return /*#__PURE__*/React.createElement("tr", {
          key: product.id
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
          className: "code",
          type: "text",
          name: "product_code",
          value: product.product_code,
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, product.id);
          }
        })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
          className: "desc",
          type: "text",
          name: "product_desc",
          value: product.product_desc,
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, product.id);
          }
        })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
          className: "qty",
          type: "text",
          name: "product_quantity",
          value: product.product_quantity,
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, product.id);
          }
        })));
      })))), /*#__PURE__*/React.createElement("textarea", {
        className: "comments",
        name: "comments",
        value: this.state.comments,
        placeholder: translate('COMMMENTS', 'COMMENTAIRES'),
        id: "",
        cols: "100",
        rows: "5",
        onChange: function onChange(e) {
          return _this3.handleCommentsChange(e);
        }
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: this.getCartRules()
        }
      }), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-envelope fa-fw"
      }), /*#__PURE__*/React.createElement("span", null, this.getEmailBranch()), this.getPhoneBranch() !== '' ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-phone fa-fw ml-4"
      }), this.getPhoneBranch()) : null)), /*#__PURE__*/React.createElement("div", {
        className: "col-lg-2 col-md-0"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-lg-3 col-md-12 grand-total"
      }, this.state.cart <= 0 ? null : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn submit btn-cart-step-1",
        onClick: this.sendSubmission,
        disabled: this.state.disabled
      }, this.state.disabled ? translate('Sent', 'Envoyé') : translate('Send', 'Envoyer'))))))));
    }
  }]);

  return CartPage;
}(Component);

CartPage.propTypes = {
  match: PropTypes.object,
  otherProducts: PropTypes.array
};
export default CartPage;